import PropTypes, { number } from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  Label,
  Input,
} from "reactstrap"

import OTPInput, { ResendOTP } from "otp-input-react"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { useHistory } from "react-router-dom"
import { withTranslation } from "react-i18next"
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { userForgetPassword } from "../../store/actions"

// import images
//import logoSm from "../../assets/images/logo-sm.png";
import logo from "../../assets/images/vsmart_logo.svg"

const ForgetPasswordPage = props => {
  const [mode, setMode] = useState(0)

  const history = useHistory()

  function handleValidSubmit(event, values) {
    props.userForgetPassword(values, props.history)
  }

  // ------------------otp-------------------
  const [OTP, setOTP] = useState("")

  return (
    <React.Fragment>
      <MetaTags>
        <title>Forget Password | Virtual Supermarket</title>
      </MetaTags>
      {/* <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2"></i>
        </Link>
      </div> */}
      {/* <div className="account-pages my-5 pt-5 background-body"> */}
      <div className="account-pages pt-5 background-body">
        <Container>
          {/* <Row className="justify-content-center"> */}
          <Row
            className="justify-content-center mt-4"
            style={{ paddingBottom: "9rem" }}
          >
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20 p-2">
                      Forget Password
                    </h5>
                    <a href="index.html" className="logo logo-admin">
                      <img src={logo} height="40" alt="logo" />
                    </a>
                  </div>
                </div>
                <CardBody className="p-4">
                  {props.forgetError && props.forgetError ? (
                    <Alert
                      color="danger"
                      style={{ marginTop: "13px" }}
                      className="mt-5"
                    >
                      {props.forgetError}
                    </Alert>
                  ) : null}
                  {props.forgetSuccessMsg ? (
                    <Alert
                      color="success"
                      style={{ marginTop: "13px" }}
                      className="mt-5"
                    >
                      {props.forgetSuccessMsg}
                    </Alert>
                  ) : null}

                  {mode === 0 ? (
                    <AvForm
                      className="form-horizontal mt-5"
                      //onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="mb-4 mt-4">
                        <center>
                          {" "}
                          <h6
                            className="mt-8 mb-4"
                            style={{ color: "#7fc4df" }}
                          >
                            Enter your Email Id to reset your Password
                          </h6>{" "}
                        </center>

                        <AvField
                          name="email"
                          label="Email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          required
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            onClick={() => {
                              setMode(1)
                            }}
                          >
                            Reset
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  ) : (
                    ""
                  )}

                  {mode === 1 ? (
                    <AvForm
                      className="form-horizontal mt-4"
                      // onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="mb-4 mt-4">
                        <center>
                          <Label style={{ color: "#7fc4df" }}>
                            Enter the Verification Code
                          </Label>
                          <h6 className="mt-8 mb-4">
                            Enter the verification code which you have received
                            on your email
                          </h6>
                        </center>

                        {/*https://github.com/shubhanus/otp-input-react/blob/master/src/lib/hooks/useOTP.js*/}
                        <div className="row" style={{ display: "flex" }}>
                          <OTPInput
                            value={OTP}
                            onChange={setOTP}
                            autoFocus
                            OTPLength={6}
                            otpType="number"
                            disabled={false}
                            // secure
                          />
                        </div>
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="Verify"
                            onClick={() => {
                              setMode(2)
                            }}
                          >
                            Verify
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  ) : (
                    ""
                  )}

                  {mode === 2 ? (
                    <AvForm
                      className="form-horizontal mt-4"
                      // onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="mb-4 mt-4">
                        <center>
                          {" "}
                          <h6
                            className="mt-8 mb-4"
                            style={{ color: "#7fc4df" }}
                          >
                            Enter your New Password
                          </h6>{" "}
                        </center>
                        <AvField
                          name="NewPassword"
                          label="New Password"
                          className="form-control"
                          placeholder="Enter New Password"
                          type="password"
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="ConfirmPassword"
                          label="Confirm Password"
                          className="form-control"
                          placeholder="Enter Confirm Password"
                          type="password"
                          required
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            onClick={() => {
                              history.push("/login")
                            }}
                          >
                            Confirm
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Remember It ?{" "}
                  <Link to="login" className="fw-medium text-primary">
                    {" "}
                    Sign In here{" "}
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} Virtual Supermarket </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func,
}

const mapStatetoProps = state => {
  const { forgetError, forgetSuccessMsg } = state.ForgetPassword
  return { forgetError, forgetSuccessMsg }
}

export default withRouter(
  connect(mapStatetoProps, { userForgetPassword })(ForgetPasswordPage)
)
